import { ButtonBase, useTheme } from "@mui/material";
import type { LucideIcon } from "lucide-react";
import type { FC } from "react";

type Props = {
	icon: LucideIcon;
	label: string;
	enabled: boolean;
	onClick: () => void;
};

export const FlatRowDatePanelArrow: FC<Props> = ({
	icon: Icon,
	label,
	enabled,
	onClick,
}) => {
	const { palette, spacingTokens, radii, iconSize, datePanel } = useTheme();

	const handleClick = () => {
		if (!enabled) return;
		onClick();
	};

	return (
		<ButtonBase
			onClick={handleClick}
			aria-disabled={!enabled}
			aria-label={label}
			sx={{
				p: spacingTokens.xs,
				borderRadius: radii.full,
				opacity: enabled ? 1 : datePanel.disabledArrowOpacity,
			}}
		>
			<Icon size={iconSize.md} color={palette.blue[600]} />
		</ButtonBase>
	);
};
